// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3715":"list","9702":"story"}[chunkId] || chunkId) + "-" + {"2217":"7b00d6cda110579d9cb6","3715":"ad3f1a95fa77c4d29822","5737":"15a0d08e772783426cef","9702":"f24f92f9dd21e621a9b4"}[chunkId] + ".css";
};